const AVATAR_FALLBACK_REGEX = /([^/]+)_profile\.(png|svg)$/i;

export const getAvatarInitials = (fullName: string = ''): string => {
    const nameParts = fullName.split(' ').filter(Boolean);

    if (!nameParts.length) {
        return '';
    }

    if (nameParts.length === 1) {
        return nameParts[0][0]?.toUpperCase() ?? '';
    }

    return `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`.toUpperCase();
};

export const getAvatarProfileType = (imageUrl: string = ''): string => {
    const image = imageUrl.trim();
    const match = image.match(AVATAR_FALLBACK_REGEX);
    return match ? match[1] : '';
};

export const shouldShowAvatarImage = (imageUrl: string = ''): boolean => {
    const image = imageUrl.trim();

    if (!image) {
        return false;
    }

    const isValidLocation = !image.startsWith('assets/') || image.includes('user-profile-image');
    return isValidLocation && !AVATAR_FALLBACK_REGEX.test(image);
};

export const getAvatarBgColor = (profileType: string = ''): string => {
    const colorMap: Record<string, string> = {
        companyAdmin: '#0664e8',
        companyConsultant: '#338bff',
        companyDepartment: '#3380ec',
        companyEmployee: '#0664e8',
        companyManager: '#2f4057',
        companyContractor: '#1b2b46',
        subcompany: '#f8fafc',
        candidate: '#f8fafc',
    };

    return colorMap[profileType] ?? '#6c757d';
};
